import { defineComponent as Q, computed as te, watch as pe, reactive as Y, isVue2 as re, isVue3 as Oe } from "vue-demi";
import * as f from "helper-js";
import { walkTreeData as ht } from "helper-js";
import Ne from "@virtual-list/vue";
import { openBlock as L, createElementBlock as V, normalizeClass as J, normalizeStyle as A, Fragment as ie, renderList as we, createCommentVNode as ve, createElementVNode as z, renderSlot as R, resolveComponent as ye, createBlock as Se, withCtx as X, createVNode as ke, createTextVNode as xe, toDisplayString as Le } from "vue";
import { makeTreeProcessor as $e, CHILDREN as me } from "@he-tree/tree-utils";
import { extendedDND as Be, context as T } from "@he-tree/dnd-utils";
/*!
 * @he-tree/vue v2.10.0-beta.2
 * Author: phphe <phphe@outlook.com> (https://github.com/phphe)
 * Homepage: https://hetree.phphe.com/
 * Released under the MIT License.
 */
let Z = !1;
const Ve = () => {
  Z = !0, setTimeout(() => {
    Z = !1;
  }, 100);
}, Ee = Q({
  // components: {},
  props: [
    "stat",
    "rtl",
    "btt",
    "indent",
    "table",
    "treeLine",
    "treeLineOffset",
    "processor"
  ],
  emits: ["open", "close", "check"],
  setup(e, { emit: t }) {
    const n = te(() => ({
      [e.rtl ? "paddingRight" : "paddingLeft"]: e.indent * (e.stat.level - 1) + "px"
    }));
    pe(
      () => e.stat.checked,
      (v) => {
        Z || e.processor.afterOneCheckChanged(e.stat) && t("check", e.stat);
      }
    ), pe(
      () => e.stat.open,
      (v) => {
        Z || (t(v ? "open" : "close", e.stat), Ve());
      }
    );
    const l = te(() => {
      const v = [], C = (o) => {
        var c;
        if (o.parent) {
          let h = (c = o.parent) == null ? void 0 : c.children.indexOf(o);
          do {
            h++;
            let p = o.parent.children[h];
            if (p) {
              if (!p.hidden)
                return !0;
            } else
              break;
          } while (!0);
        }
        return !1;
      }, b = e.rtl ? "right" : "left", D = e.btt ? "top" : "bottom";
      let i = e.stat;
      for (; i; ) {
        let o = (i.level - 2) * e.indent + e.treeLineOffset;
        const c = C(i), h = () => {
          v.push({
            style: {
              [b]: o + "px",
              [D]: c ? 0 : "50%"
            }
          });
        };
        i === e.stat ? i.level > 1 && h() : c && h(), i = i.parent;
      }
      return v;
    }), s = te(() => {
      let v = (e.stat.level - 2) * e.indent + e.treeLineOffset;
      return {
        [e.rtl ? "right" : "left"]: v + "px"
      };
    });
    return { indentStyle: n, vLines: l, hLineStyle: s };
  }
  // data() {
  //   return {}
  // },
  // computed: {},
  // watch: {},
  // methods: {},
  // created() {},
  // mounted() {}
}), se = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [l, s] of t)
    n[l] = s;
  return n;
}, Pe = { class: "tree-node-inner" }, Fe = {
  key: 1,
  class: "tree-node",
  ref: "el"
};
function Ie(e, t, n, l, s, v) {
  return e.table ? (L(), V("tr", Fe, [
    R(e.$slots, "default", { indentStyle: e.indentStyle })
  ], 512)) : (L(), V("div", {
    key: 0,
    class: J(["tree-node", { "tree-node--with-tree-line": e.treeLine }]),
    style: A(e.indentStyle),
    ref: "el"
  }, [
    e.treeLine ? (L(), V(ie, { key: 0 }, [
      (L(!0), V(ie, null, we(e.vLines, (C) => (L(), V("div", {
        class: "tree-line tree-vline",
        style: A(C.style)
      }, null, 4))), 256)),
      e.stat.level > 1 ? (L(), V("div", {
        key: 0,
        class: "tree-line tree-hline",
        style: A(e.hLineStyle)
      }, null, 4)) : ve("", !0)
    ], 64)) : ve("", !0),
    z("div", Pe, [
      R(e.$slots, "default", { indentStyle: e.indentStyle })
    ])
  ], 6));
}
const Te = /* @__PURE__ */ se(Ee, [["render", Ie]]);
function _e(e, t = {}) {
  const n = {
    ...t,
    statHandler(l) {
      return this._statHandler2 && (l = this._statHandler2(l)), ne(t.statHandler, Y(l));
    },
    statsHandler(l) {
      return ne(t.statsHandler, Y(l));
    },
    statsFlatHandler(l) {
      return ne(t.statsFlatHandler, Y(l));
    }
  };
  return $e(e, n);
}
function ne(e, t) {
  return e ? e(t) : t;
}
const Re = Q({
  components: { VirtualList: Ne, TreeNode: Te },
  props: {
    // for vue2
    value: { required: re, type: Array },
    // for vue3
    modelValue: { required: Oe, type: Array },
    updateBehavior: {
      type: String,
      default: "modify"
    },
    processor: {
      type: Object,
      default: () => _e([], {
        noInitialization: !0
      })
    },
    childrenKey: { type: String, default: "children" },
    /**
     * for default slot. 用于默认插槽
     */
    textKey: { type: String, default: "text" },
    /**
     * node indent. 节点缩进
     */
    indent: { type: Number, default: 20 },
    /**
     * Enable virtual list. 启用虚拟列表
     */
    virtualization: { type: Boolean, default: !1 },
    /**
     * Render count for virtual list at start. 虚拟列表初始渲染数量.
     */
    virtualizationPrerenderCount: { type: Number, default: 20 },
    /**
     * Open all nodes by default. 默认打开所有节点.
     */
    defaultOpen: { type: Boolean, default: !0 },
    statHandler: { type: Function },
    /**
     * From right to left. 由右向左显示.
     */
    rtl: { type: Boolean, default: !1 },
    /**
     * From bottom to top. 由下向上显示
     */
    btt: { type: Boolean, default: !1 },
    /**
     * Display as table
     */
    table: { type: Boolean, default: !1 },
    watermark: { type: Boolean, default: !1 },
    nodeKey: {
      type: [String, Function],
      default: "index"
    },
    treeLine: { type: Boolean, default: !1 },
    treeLineOffset: { type: Number, default: 8 }
  },
  emits: [
    "update:modelValue",
    "click:node",
    "open:node",
    "close:node",
    "check:node",
    "beforeDragStart",
    "before-drag-start",
    "after-drop",
    "change",
    "enter",
    "leave"
  ],
  data() {
    return {
      stats: [],
      statsFlat: [],
      dragNode: null,
      dragOvering: !1,
      placeholderData: {},
      placeholderColspan: 1,
      batchUpdateWaiting: !1,
      self: this,
      _ignoreValueChangeOnce: !1
    };
  },
  computed: {
    valueComputed() {
      return (re ? this.value : this.modelValue) || [];
    },
    visibleStats() {
      const { statsFlat: e, isVisible: t } = this;
      let n = e;
      return this.btt && (n = n.slice(), n.reverse()), n.filter((l) => t(l));
    },
    rootChildren() {
      return this.stats;
    }
  },
  methods: {
    _emitValue(e) {
      this.$emit(re ? "input" : "update:modelValue", e);
    },
    /**
     * private method
     * @param value
     */
    _updateValue(e) {
      return this.updateBehavior === "disabled" ? !1 : (e !== this.valueComputed && (this._ignoreValueChangeOnce = !0), this._emitValue(e), !0);
    },
    getStat: ae(
      S("getStat")
    ),
    has: ae(S("has")),
    updateCheck: S(
      "updateCheck"
    ),
    getChecked: S(
      "getChecked"
    ),
    getUnchecked: S(
      "getUnchecked"
    ),
    openAll: S("openAll"),
    closeAll: S("closeAll"),
    openNodeAndParents: S(
      "openNodeAndParents"
    ),
    isVisible: S("isVisible"),
    move: be("move"),
    add: ae(
      be("add")
    ),
    addMulti(e, t, n) {
      this.batchUpdate(() => {
        let l = n;
        for (const s of e)
          this.add(s, t, l), l != null && l++;
      });
    },
    remove: S("remove"),
    removeMulti(e) {
      let t = [...e];
      this.batchUpdate(() => {
        for (const n of t)
          this.remove(n);
      });
    },
    iterateParent: S(
      "iterateParent"
    ),
    getSiblings: S(
      "getSiblings"
    ),
    getData: S("getData"),
    getRootEl() {
      return this.$refs.vtlist.listElRef;
    },
    batchUpdate(e) {
      const t = this.ignoreUpdate(e);
      return this.batchUpdateWaiting || this._updateValue(
        this.updateBehavior === "new" ? this.getData() : this.valueComputed
      ), t;
    },
    ignoreUpdate(e) {
      const t = this.batchUpdateWaiting;
      this.batchUpdateWaiting = !0;
      const n = e();
      return this.batchUpdateWaiting = t, n;
    }
  },
  watch: {
    processor: {
      immediate: !0,
      handler(e) {
        if (e) {
          const t = (n) => {
            if (n) {
              const { childrenKey: l } = this;
              return n[l] || (n[l] = []), n[l];
            } else
              return this.valueComputed;
          };
          e._statHandler2 = this.statHandler ? (n) => n.data === this.placeholderData ? n : this.statHandler(n) : null, e.afterSetStat = (n, l, s) => {
            const { childrenKey: v, updateBehavior: C } = this;
            let b = this.valueComputed;
            if (C === "new") {
              if (this.batchUpdateWaiting)
                return;
              b = this.getData();
            } else if (C === "modify") {
              const D = t(l == null ? void 0 : l.data);
              D.includes(n.data) || D.splice(s, 0, n.data);
            }
            this.batchUpdateWaiting || this._updateValue(b);
          }, e.afterRemoveStat = (n) => {
            var C;
            const { childrenKey: l, updateBehavior: s } = this;
            let v = this.valueComputed;
            if (s === "new") {
              if (this.batchUpdateWaiting)
                return;
              v = this.getData();
            } else if (s === "modify") {
              const b = t((C = n.parent) == null ? void 0 : C.data);
              f.arrayRemove(b, n.data);
            }
            this.batchUpdateWaiting || this._updateValue(v);
          };
        }
        e.initialized || (e.data = this.valueComputed, Object.assign(
          e,
          f.objectOnly(this, ["childrenKey", "defaultOpen"])
        ), e.init(), e.updateCheck()), this.stats = e.stats, this.statsFlat = e.statsFlat, e.data !== this.valueComputed && this._updateValue(e.data);
      }
    },
    valueComputed: {
      handler(e) {
        if (this.dragOvering || this.dragNode || this._ignoreValueChangeOnce)
          this._ignoreValueChangeOnce = !1;
        else {
          const { processor: n } = this;
          n.data = e, n.init(), this.stats = n.stats, this.statsFlat = n.statsFlat;
        }
      }
    }
  },
  created() {
  },
  mounted() {
    typeof window < "u" && (this.watermark === !1 && (window._heTreeWatermarkDisabled = !0), this.watermark && !window._heTreeWatermarkDisabled && (window._heTreeWatermark || (window._heTreeWatermark = !0, console.log(
      "%c[he-tree] Vue tree component:  https://hetree.phphe.com",
      "color:#0075ff; font-size:14px;"
    ))));
  }
});
function S(e) {
  return function(...t) {
    return this.processor[e](...t);
  };
}
function be(e) {
  return function(...t) {
    return this.batchUpdate(() => this.processor[e](...t));
  };
}
function ae(e) {
  return function(t, ...n) {
    return t && (t = Y(t)), e.call(this, t, ...n);
  };
}
const Ue = {
  key: 0,
  class: "drag-placeholder he-tree-drag-placeholder"
}, Me = ["colspan"], He = { class: "drag-placeholder he-tree-drag-placeholder" };
function We(e, t, n, l, s, v) {
  const C = ye("TreeNode"), b = ye("VirtualList");
  return L(), Se(b, {
    class: J(["he-tree", {
      "he-tree--rtl rtl": e.rtl,
      "he-tree--drag-overing drag-overing": e.dragOvering
    }]),
    ref: "vtlist",
    items: e.visibleStats,
    disabled: !e.virtualization,
    table: e.table,
    itemKey: e.nodeKey
  }, {
    prepend: X(() => [
      R(e.$slots, "prepend", { tree: e.self })
    ]),
    default: X(({ item: D, index: i }) => [
      ke(C, {
        "vt-index": i,
        class: J([
          D.class,
          {
            "drag-placeholder-wrapper": D.data === e.placeholderData,
            "dragging-node": D === e.dragNode
          }
        ]),
        style: A(D.style),
        stat: D,
        rtl: e.rtl,
        btt: e.btt,
        indent: e.indent,
        table: e.table,
        treeLine: e.treeLine,
        treeLineOffset: e.treeLineOffset,
        processor: e.processor,
        onClick: (o) => e.$emit("click:node", D),
        onOpen: t[0] || (t[0] = (o) => e.$emit("open:node", o)),
        onClose: t[1] || (t[1] = (o) => e.$emit("close:node", o)),
        onCheck: t[2] || (t[2] = (o) => e.$emit("check:node", o))
      }, {
        default: X(({ indentStyle: o }) => [
          D.data === e.placeholderData ? (L(), V(ie, { key: 0 }, [
            e.table ? (L(), V("td", {
              key: 1,
              style: A(o),
              colspan: e.placeholderColspan
            }, [
              z("div", He, [
                R(e.$slots, "placeholder", { tree: e.self })
              ])
            ], 12, Me)) : (L(), V("div", Ue, [
              R(e.$slots, "placeholder", { tree: e.self })
            ]))
          ], 64)) : R(e.$slots, "default", {
            key: 1,
            node: D.data,
            stat: D,
            indentStyle: o,
            tree: e.self
          }, () => [
            xe(Le(D.data[e.textKey]), 1)
          ])
        ]),
        _: 2
      }, 1032, ["vt-index", "class", "style", "stat", "rtl", "btt", "indent", "table", "treeLine", "treeLineOffset", "processor", "onClick"])
    ]),
    append: X(() => [
      R(e.$slots, "append", { tree: e.self })
    ]),
    _: 3
  }, 8, ["class", "items", "disabled", "table", "itemKey"]);
}
const Ke = /* @__PURE__ */ se(Re, [["render", We]]);
let a = null, r = null, G, K, _, q, le, N, oe;
const lt = {
  get startInfo() {
    return G;
  },
  get targetInfo() {
    return K;
  },
  get dragNode() {
    return N;
  },
  get startTree() {
    return a;
  },
  get targetTree() {
    return r;
  },
  get closestNode() {
    return oe;
  }
}, Ae = Q({
  extends: Ke,
  props: {
    triggerClass: { type: [String, Array] },
    disableDrag: Boolean,
    disableDrop: Boolean,
    eachDraggable: {
      type: Function
    },
    eachDroppable: {
      type: Function
    },
    rootDroppable: {
      type: [Boolean, Function],
      default: !0
    },
    /**
     * open closed node when drag over
     */
    dragOpen: { type: Boolean, default: !0 },
    dragOpenDelay: { type: Number, default: 0 },
    /**
     * e.g.: you can load children by ajax in the hook
     */
    beforeDragOpen: { type: Function },
    resolveStartMovePoint: {
      type: [String, Function]
    },
    /**
     * if remove placeholder when drag leave a tree
     */
    keepPlaceholder: { type: Boolean },
    /**
     * prevent drop if greater than maxLevel
     */
    maxLevel: { type: Number },
    /**
     * copy when drag
     */
    dragCopy: { type: Boolean },
    /**
     * return new data when drag copy
     */
    dragCopyDataHandler: {
      type: Function
    },
    onExternalDragOver: {
      type: Function
    },
    externalDataHandler: {
      type: Function
    },
    // hook of event HTML5 Drag and Drop API's dragstart event
    ondragstart: {
      type: Function
    },
    // throttle interval for dragover event
    dragOverThrottleInterval: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      treeDraggableInstance: null
    };
  },
  computed: {},
  methods: {
    getNodeByElement(e) {
      const t = e.getAttribute("vt-index");
      return t == null ? null : this.visibleStats[t];
    },
    isDraggable(e) {
      if (this.disableDrag)
        return !1;
      if (e.draggable != null)
        return e.draggable;
      if (this.eachDraggable) {
        const n = this.eachDraggable(e);
        if (n != null)
          return n;
      }
      const { parent: t } = e;
      return t ? this.isDraggable(t) : !0;
    },
    isDroppable(e) {
      if (this.disableDrop)
        return !1;
      if (!e)
        return f.resolveValueOrGettter(this.rootDroppable, [this, a]);
      if (e.droppable != null)
        return e.droppable;
      if (this.eachDroppable) {
        const n = this.eachDroppable(e);
        if (n != null)
          return n;
      }
      const { parent: t } = e;
      return t ? this.isDroppable(t) : !0;
    },
    _eachDroppable() {
      var e;
      return f.resolveValueOrGettter((e = this._isDragCopy) == null ? void 0 : e.call(this), [this]);
    }
  },
  mounted() {
    const e = (i, o) => {
      let c = !0;
      return a && a !== this && (c = c && this._isMoved), this.table && !this._isDragCopy && (c = c && this._isDragCopy), c && (i.x !== o.x || i.y !== o.y);
    }, t = (i, o) => {
      r.ignoreUpdate(() => {
        if (!r.has(r.placeholderData)) {
          if (r.table) {
            let h = 0;
            const p = r.getRootEl().querySelector("tr");
            if (p)
              for (const {
                value: y
              } of f.iterateAll(p.children))
                f.css(y, "display") !== "none" && (h += y.colSpan || 1);
            h < 1 && (h = 1), r.placeholderColspan = h;
          }
          r.add(r.placeholderData);
        }
        const c = r.getStat(r.placeholderData);
        r.move(c, i, o);
      });
    }, n = () => {
      const i = this;
      if (i.has(i.placeholderData))
        return i.remove(i.getStat(i.placeholderData)), !0;
    }, l = (i) => {
      i ? T.dropEffect = a != null && a.dragCopy ? "copy" : "move" : T.dropEffect = "none";
    }, s = (i) => {
      const o = this;
      i ? l(!0) : o.keepPlaceholder ? o.has(o.placeholderData) || l(!1) : (n(), l(!1));
    };
    let v = { x: 0, y: 0 };
    const C = this.getRootEl();
    let b = null;
    const D = () => {
      r != null && r.has(r.placeholderData) && r.ignoreUpdate(() => {
        r.remove(r.getStat(r.placeholderData)), a && (a.dragNode.hidden = !1, a.dragOvering = !1);
      });
    };
    this.treeDraggableInstance = Be(C, {
      beforeDragStart: (i) => {
        if (!T.triggerElement)
          return;
        let o = this.triggerClass;
        (!o || o.length === 0) && (o = "tree-node");
        let c = f.toArrayIfNot(o), h = f.findParent(
          T.triggerElement,
          (p) => {
            if (f.hasClassIn(p, c))
              return !0;
            if (f.hasClass(p, "tree-node"))
              return "break";
          },
          { withSelf: !0, until: C }
        );
        if (b = f.findParent(
          h,
          (p) => {
            if (f.hasClass(p, "tree-node"))
              return !0;
          },
          { withSelf: !0, until: C }
        ), !!b) {
          if (N = this.getNodeByElement(b), !N)
            throw "Can't find drag node";
          if (this.isDraggable(N))
            return this.$emit("before-drag-start", N), this.$emit("beforeDragStart", N), C;
        }
      },
      onDragStart: (i) => {
        var p, y, u;
        if (!b || !N)
          return;
        {
          const { x: g, y: k } = b.getBoundingClientRect(), { clientX: m, clientY: E } = i;
          (p = i.dataTransfer) == null || p.setDragImage(
            b,
            m - g,
            E - k
          );
        }
        le = { x: i.clientX, y: i.clientY }, a = this, a.dragNode = N, q = (() => {
          if (this.resolveStartMovePoint === "mouse")
            return { x: i.clientX, y: i.clientY };
          if (typeof this.resolveStartMovePoint == "function")
            return this.resolveStartMovePoint(b);
          {
            let g, k = 0;
            if (this.table) {
              let m = b.getBoundingClientRect();
              g = { x: m.x, y: m.y }, this.rtl && (g.x = m.right), k = m.height;
            } else if (!this.rtl)
              g = b.children[0].getBoundingClientRect().toJSON(), k = g.height;
            else {
              const m = b.children[0].getBoundingClientRect();
              g = {
                x: m.right,
                y: m.y
              }, k = m.height;
            }
            return this.btt && (g.y += k), g;
          }
        })(), this.dragOvering = !0;
        const c = a.getSiblings(a.dragNode), h = c.indexOf(N);
        G = {
          tree: a,
          dragNode: N,
          parent: N.parent,
          siblings: c,
          indexBeforeDrop: h
        }, r = this, (y = i.dataTransfer) == null || y.setData(
          "text",
          `he-tree drag start at ${(/* @__PURE__ */ new Date()).toISOString()}`
        ), a._eachDroppable() || setTimeout(() => {
          N.hidden = !0, t(N.parent, h + 1);
        }, 0), (u = this.ondragstart) == null || u.call(this, i);
      },
      // onDragEnter, onDragLeave, onDragOver, onDrop execute on target tree
      onEnter: (i) => {
        this.$emit("enter", i);
      },
      onLeave: (i) => {
        _ = null, this.dragOvering = !1, T.preventDefault = !1, n(), this.$emit("leave", i);
      },
      onDragOver: f.applyFinally(
        (i) => {
          if (!a) {
            if (!this.onExternalDragOver || this.onExternalDragOver(i) === !1)
              return;
            T.preventDefault = !0;
          }
          if (this.dragOverThrottleInterval > 0)
            if (this._lastValidDragOver == null)
              this._lastValidDragOver = (/* @__PURE__ */ new Date()).getTime();
            else {
              let d = (/* @__PURE__ */ new Date()).getTime();
              if (
                // @ts-expect-error
                d - this._lastValidDragOver > this.dragOverThrottleInterval
              )
                this._lastValidDragOver = d;
              else
                return;
            }
          const o = { x: i.clientX, y: i.clientY }, c = e(o, v);
          if (v = o, !c)
            return;
          this.dragOvering = !0, r = this;
          const h = q ? {
            x: q.x + (o.x - le.x),
            y: q.y + (o.y - le.y)
          } : { ...o }, { btt: p, rtl: y } = r;
          if (r.disableDrop) {
            T.dropEffect = "none";
            return;
          }
          let u, g;
          const k = r.getRootEl().querySelectorAll(".tree-node"), m = [];
          k.forEach((d) => {
            !f.hasClassIn(d, [
              "drag-placeholder-wrapper",
              "dragging-node"
            ]) && f.css(d, "display") !== "none" && m.push(d);
          });
          const E = f.binarySearch(
            m,
            (d) => f.getBoundingClientRect(d)[p ? "bottom" : "top"] - h.y,
            { returnNearestIfNoHit: !0 }
          );
          let O = null, F, ee;
          E.hit || (E.greater ? p || (O = E.index - 1, m[O] || O++) : p && (O = E.index + 1, m[O] || O--)), O == null && (O = E.index), F = m[O], ee = p ? m[O - 1] : m[O + 1], u = F && r.getNodeByElement(F), g = ee && r.getNodeByElement(ee);
          const { indent: j } = r, $ = f.cacheFunction(() => {
            if (r.table) {
              let d = f.getBoundingClientRect(F).toJSON();
              const x = j * (u.level - 1);
              return y ? (d.width -= x, d.right -= x) : d.x += x, d;
            } else
              return f.getBoundingClientRect(F.firstElementChild);
          }).action, de = f.cacheFunction(() => p ? h.y > $().y + $().height / 2 : h.y < $().y + $().height / 2).action, De = f.cacheFunction(() => p ? !F || O === m.length - 1 && de() : !F || O === 0 && de()).action, he = f.cacheFunction(
            () => y ? h.x - ($().x + $().width) : $().x - h.x
          ).action, Ce = f.cacheFunction(
            () => y ? h.x < $().x + $().width - j : h.x > $().x + j
          ).action;
          let P;
          if (De())
            P = 1, u = null;
          else if (u)
            he() > 0 ? P = u.level - Math.ceil(he() / j) : Ce() ? P = u.level + 1 : P = u.level;
          else return;
          g && P < g.level && (P = g.level), (async () => {
            let d, x, I = !1, U = null;
            const H = async (w) => {
              if (w.open)
                return !0;
              if (r.dragOpen)
                if (r.dragOpenDelay)
                  if (U = w, _ === w)
                    I = !0;
                  else {
                    let B = f.promisePin();
                    _ = w;
                    const M = w;
                    return setTimeout(async () => {
                      M !== _ ? (I = !0, B.resolve(!0)) : (r.beforeDragOpen && await r.beforeDragOpen(w), M !== _ ? (I = !0, B.resolve(!0)) : (w.open = !0, U = null, B.resolve(!0)));
                    }, r.dragOpenDelay), await B.promise;
                  }
                else
                  return r.beforeDragOpen && await r.beforeDragOpen(w), w.open = !0, !0;
              else
                return !1;
            }, W = async () => {
              if (r.isDroppable(u) && await H(u)) {
                if (I)
                  return;
                d = u, x = null;
              } else
                return !1;
            }, ue = (w = P) => {
              let B = u, M = [];
              for (; B && B.level >= w; )
                B = B.parent || null, M.unshift(B);
              let ce = 0;
              for (const ge of M) {
                if (r.isDroppable(ge))
                  return d = ge, x = M[ce + 1] || u, !0;
                ce++;
              }
              return !1;
            };
            oe = u || null, u ? P > u.level ? await W() === !1 && ue(u.level) : ue() === !1 && await W() : r.isDroppable(null) && (d = null), _ = U;
            const fe = !!(!I && (d || d === null));
            return {
              cancelled: I,
              success: fe,
              parent: d,
              index: fe ? x ? (d ? d.children : r.stats).filter((w) => w.data !== r.placeholderData).indexOf(x) + 1 : 0 : -1
            };
          })().then((d) => {
            if (!d.cancelled) {
              if (!d.success) {
                s(!1);
                return;
              }
              if (r.maxLevel != null && r.maxLevel > 0) {
                let x = 1;
                if (a) {
                  const U = a.dragNode;
                  let H = 0;
                  f.walkTreeData(
                    U,
                    (W) => {
                      W.level > H && (H = W.level);
                    },
                    {
                      childrenKey: me
                    }
                  ), x = H - U.level + 1;
                }
                if (x + (d.parent ? d.parent.level : 0) > r.maxLevel) {
                  s(!1);
                  return;
                }
              }
              s(!0), t(d.parent, d.index);
            }
          });
        },
        () => {
        }
      ),
      onDrop: (i) => {
        r = this;
        const o = !a;
        if (!r)
          return;
        const c = a == null ? void 0 : a.dragNode;
        let h, p = (() => {
          var u;
          let y = !0;
          if (!r.has(r.placeholderData))
            y = !1;
          else if (o)
            h = (u = this.externalDataHandler) == null ? void 0 : u.call(this, i), y = h != null;
          else if (!a.dragCopy) {
            const g = r.getStat(
              r.placeholderData
            );
            a === r && g.parent === c.parent && (f.findTreeData(c, (k) => k === g), me);
          }
          return y;
        })();
        if (p) {
          const y = r.getStat(r.placeholderData), u = r.getSiblings(y);
          K = {
            tree: r,
            dragNode: c,
            parent: y.parent,
            siblings: u,
            indexBeforeDrop: u.indexOf(y)
          };
        }
        (() => {
          if (D(), p) {
            let y = K.indexBeforeDrop;
            a && !a.dragCopy && a === r && G.parent == K.parent && G.indexBeforeDrop < y && y--, a && a !== r && !a._eachDroppable() && a.batchUpdate(() => {
              a.remove(c), a.updateCheck();
            }), r.batchUpdate(() => {
              let u = a == null ? void 0 : a.dragNode, g;
              h ? g = h : a._eachDroppable() && (g = f.cloneTreeData(a.dragNode.data, {
                childrenKey: a.childrenKey
              }), a.dragCopyDataHandler && (g = a.dragCopyDataHandler(g))), g && (r.add(g), u = r.getStat(g)), r.move(u, K.parent, y), r.updateCheck();
            });
          }
          r.$emit("after-drop"), p && (a && (a.dragCopy || a.$emit("change")), r !== a && r.$emit("change"));
        })();
      },
      onDragEnd: (i) => {
        D(), a && (a.dragNode && (a.dragNode.hidden = !1), a.dragNode = null, a.dragOvering = !1, a = null), r = null, _ = null, N = null, oe = null;
      }
    });
  },
  unmounted() {
    var e;
    (e = this.treeDraggableInstance) == null || e.destroy();
  }
}), ze = Q({
  props: {
    open: { type: Boolean }
  }
}), je = /* @__PURE__ */ z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, [
  /* @__PURE__ */ z("title", null, "chevron-right"),
  /* @__PURE__ */ z("path", { d: "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" })
], -1), Xe = [
  je
];
function qe(e, t, n, l, s, v) {
  return L(), V("a", {
    class: J(["he-tree__open-icon", { open: e.open }])
  }, Xe, 2);
}
const it = /* @__PURE__ */ se(ze, [["render", qe]]);
function ot(e, t) {
  try {
    return {
      mixins: [Ae],
      created: new Function(Ye(e, t))()
    };
  } catch {
    throw new Error("he-tree-pro: wrong secret key");
  }
}
function Ye(e, t) {
  e = encodeURIComponent(e), e.length % 2 === 1 && (e += "h"), e = e.split("").reverse().join(""), t = atob(t);
  for (let n = 0; n < e.length; n += 2) {
    const l = e[n], s = e[n + 1];
    t = Ge(t, l, s);
  }
  return Je(
    "arb=inowc=ocmet;etrnfucton){are=1,=tistr{evod !=b}ath(){e&(c_htreWtemak=)=e,._sMve=(=>._eteeatrmrkd.israCoy=)=d.abe,._acDrppbl=(=>.dagop)}",
    t
  );
}
function Ge(e, t, n) {
  let l = "";
  for (let s = 0; s < e.length; s++) {
    const v = e[s];
    v === t ? l += n : v === n ? l += t : l += v;
  }
  return l;
}
function Je(e, t) {
  let n = 0, l = "";
  for (; ; ) {
    let s;
    if (s = n, s >= t.length || (l += t[s], s = n * 2, s >= e.length) || (l += e[s], s += 1, s >= e.length))
      break;
    l += e[s], n++;
  }
  return l;
}
export {
  Ke as BaseTree,
  Ae as Draggable,
  it as OpenIcon,
  Te as TreeNode,
  lt as context,
  lt as dragContext,
  ot as pro,
  ht as walkTreeData
};
